import {Component, OnDestroy, OnInit} from '@angular/core';
import {Globals} from 'app/shared/globals/globals';
import { CompanyFeatures } from "@app/models/company-features.model";
import {ActivatedRoute} from '@angular/router';
import {BreadcrumbService} from 'app/shared/breadcrumbs/breadcrumbs.service';
import {Breadcrumb} from 'app/models/breadcrumb.model';
import {environment} from 'environments/environment';
import {CompanySetUpStepType} from '@app/models/company/company-set-up-steps/company-set-up-step-type.enum';
import {SurveysMessages} from '@app/surveys/surveys.messages';
import {GoalsMessages} from '@app/goals/goals.messages';
import {FeedbackMessages} from '@app/feedback/feedback.messages';
import {OneToOneMessages} from '@app/domain/one_to_one/locale/one-to-one.messages';
import {AdminMessages} from '@app/admin/admin.messages';
import { CareerMessages } from '@app/domain/career/locale/career.messages';

@Component({
  selector: 'app-company-dashboard',
  templateUrl: './company-dashboard.component.html',
  styleUrls: ['./company-dashboard.component.scss']
})
export class CompanyDashboardComponent implements OnDestroy {
  public readonly environment = environment;
  public readonly eFeature = CompanyFeatures;
  public readonly eCompanySetUpStepType = CompanySetUpStepType;
  public readonly eSurveysMessages = SurveysMessages;
  public readonly eGoalsMessages = GoalsMessages;
  public readonly eFeedbackMessages = FeedbackMessages;
  public readonly eOneToOneMessages = OneToOneMessages;
  public readonly eAdminMessages = AdminMessages;
  public readonly eCareerMessages = CareerMessages;

  breadcrumb: Breadcrumb;

  companySetupSteps = [
    CompanySetUpStepType.CREATE_USERS,
    CompanySetUpStepType.INVITE_ALL_USERS,
    CompanySetUpStepType.CREATE_DEPARTMENTS,
    CompanySetUpStepType.CREATE_OFFICE_LOCATIONS,
    CompanySetUpStepType.CREATE_TAGS,
    CompanySetUpStepType.CREATE_POSITIONS,
    CompanySetUpStepType.CREATE_COMPETENCIES,
    CompanySetUpStepType.SET_FISCAL_YEAR
  ];

  allSetupSteps = Object.values(CompanySetUpStepType);

  get setupComplete(): boolean {
    if (!this.globals.company) {
      return false;
    }

    return this.globals.company.setUpComplete;
  }

  constructor(
      public globals: Globals,
      public route: ActivatedRoute,
      private breadcrumbService: BreadcrumbService
  ) {
    this.breadcrumb = this.breadcrumbService.init(this.route);
  }

  ngOnDestroy(): void {
    this.breadcrumbService.remove(this.breadcrumb);
  }

  openOffersPage(): void {
    const url = 'https://getfrankli.com/offers';
    window.open(url, '_blank');
  }
}
